export enum ETipoVisualizacaoMateria {
  PDF = 1,
  HTML = 2
}